class StepManager {
  constructor(reportId) {
    this.reportId = reportId;
    this.steps = document.getElementById(reportId).querySelectorAll('[data-step]');
  }

  showStep(stepName) {
    this.steps.forEach(step => {
      if (step.dataset.step === stepName) {
        step.classList.remove('invisible');
      } else {
        step.classList.add('invisible');
      }
    });
  }
}

export {StepManager};
